import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Typography, Badge, Button, Box, Menu, MenuItem } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SearchIcon from '@mui/icons-material/Search';
import { Link as RouterLink, useLocation } from 'react-router-dom';

function Navbar({ cartItemCount, isLoggedIn, user, handleLogout }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();
  const isComingSoonPage = location.pathname === '/';

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const titleProps = isComingSoonPage
    ? { component: 'div' }
    : { component: RouterLink, to: '/beta' };


  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h4"
          {...titleProps}
          sx={{
            flexGrow: 1,
            textDecoration: 'none',
            color: 'inherit',
            fontFamily: 'Oswald, sans-serif',
            letterSpacing: '.1rem',
            textShadow: '1px 1px 3px rgba(0,0,0,0.4)',
            cursor: isComingSoonPage ? 'default' : 'pointer',
          }}
        >
          <Box component="span" sx={{ fontWeight: 700 }}>
            Victory
          </Box>
          <Box component="span" sx={{ fontWeight: 300, color: '#90caf9' }}>Pix</Box>
        </Typography>
        
        {!isComingSoonPage && (
          <>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              {!isLoggedIn ? (
                <>
                  <Button color="inherit" component={RouterLink} to="/login">Login</Button>
                  <Button color="inherit" component={RouterLink} to="/register">Register</Button>
                </>
              ) : (
                <Button color="inherit" onClick={handleLogout}>Logout</Button>
              )}
              
                        {isLoggedIn && user && user.role !== 'racer' && (
                <Button color="inherit" component={RouterLink} to="/races">Races</Button>
              )}
              {isLoggedIn && (
                <Button color="inherit" component={RouterLink} to="/dashboard">Dashboard</Button>
              )}
              {isLoggedIn && user && user.role === 'admin' && (
                <>
                  <Button color="inherit" onClick={handleMenu}>Admin Tools <ArrowDropDownIcon /></Button>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    <MenuItem onClick={handleClose} component={RouterLink} to="/users">User List</MenuItem>
                    <MenuItem onClick={handleClose} component={RouterLink} to="/create-race">Create Race</MenuItem>
                    <MenuItem onClick={handleClose} component={RouterLink} to="/generate-director-token">Invite Director</MenuItem>
                    <MenuItem onClick={handleClose} component={RouterLink} to="/generate-photographer-token">Invite Photographer</MenuItem>
                  </Menu>
                </>
              )}
              <Button color="inherit" component={RouterLink} to="/race-search">Find Race <SearchIcon sx={{ ml: 1 }} /></Button>
            </Box>
            <IconButton color="inherit" component={RouterLink} to="/cart">
              <Badge badgeContent={cartItemCount} color="secondary">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
